import React from 'react'
import OrganizationSettings from 'src/app/OrganizationSettings/OrganizationSettings'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import ManageSubscriptionAppRoute from 'src/navigation/appRoutes/organization//manageSubscription.appRoute'
import APIKeysAppRoute from 'src/navigation/appRoutes/organization/APIKeysAppRoute'
import AutomationRulesAppRoute from 'src/navigation/appRoutes/organization/automationRules.appRoute'
import BusinessRulesAppRoute from 'src/navigation/appRoutes/organization/businessRules.appRoute'
import DepartmentDetailsAppRoute from 'src/navigation/appRoutes/organization/departmentDetails.appRoute'
import DepartmentsAppRoute from 'src/navigation/appRoutes/organization/departments.appRoute'
import ExpenseCategoriesAppRoute from 'src/navigation/appRoutes/organization/expenseCategories.appRoute'
import ExpenseCategoryLabelsAppRoute from 'src/navigation/appRoutes/organization/expenseCategoryLabels.appRoute'
import ExpenseSettingsAppRoute from 'src/navigation/appRoutes/organization/expenseSettings.appRoute'
import OrganizationInfoAppRoute from 'src/navigation/appRoutes/organization/organizationInfo.appRoute'
import IntegrationsAppRoute from 'src/navigation/appRoutes/organization/organizationIntegrations.appRoute'
import ReimbursementsAppRoute from 'src/navigation/appRoutes/organization/reimbursements.appRoute'
import { organizationSettingsRouteProps } from 'src/navigation/routeProps'

const OrganizationSettingsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettings,
  routeProps: organizationSettingsRouteProps,
  component: <OrganizationSettings />,
  subRoutes: [
    ExpenseCategoriesAppRoute,
    DepartmentsAppRoute,
    IntegrationsAppRoute,
    BusinessRulesAppRoute,
    ReimbursementsAppRoute,
    ExpenseSettingsAppRoute,
    OrganizationInfoAppRoute,
    ManageSubscriptionAppRoute,
    APIKeysAppRoute,
    AutomationRulesAppRoute
  ],
  exceptions: [ExpenseCategoryLabelsAppRoute, DepartmentDetailsAppRoute],
  meta: { contentType: SidenavContentType.Settings },
}

export default OrganizationSettingsAppRoute
